import { CONTENTFUL_FEATURE_KEY } from '../contentful/contentful.reducer';
import { FAVOURITES_FEATURE_KEY } from '../favourites/favourites.reducer';

export const persistenceKeys = [
  { [CONTENTFUL_FEATURE_KEY]: ['nextSyncToken'] },
  FAVOURITES_FEATURE_KEY,
];
